import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';
import { WMS1022_R01DetailDto, WMS1022_R01Dto, WMS1022_R01HeaderDto, WMS1022_R01LotDto } from "./Dto_WMS1022_R01";
import { WMS1022_R01Filter } from "./Store_WMS1022_R01";
import { WmsTransportHeaderDto } from "src/dtos/wmsTransport/wmsTransportDto";


const baseUrl = `${config.apiUrl}/WMS1022_R01`;

const getParams = (filter: Partial<WMS1022_R01Filter>, listLength?: number) => {	
	return {
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		customCd: filter.customCd || undefined,	

		listLength: listLength || 0
	}
}

export const getWMS1022_R01List = async (option: string, params: Partial<WMS1022_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<WMS1022_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getWMS1022_R01AllCount = async (params: Partial<WMS1022_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

export const getWMS1022_R01One = async (wmsOrderNo: string) => {
	const url = `${baseUrl}/one/${wmsOrderNo}`;

	return await getData<ResponseDto<WMS1022_R01HeaderDto>>(url);
}

export const getWMS1022_R01TransportHeader = async (wmsOrderNo: string) => {
    const url = `${baseUrl}/transport/${wmsOrderNo}`;

    return await getData<ResponseDto<WMS1022_R01HeaderDto>>(url);
}

export const getWMS1022_R01DetailList = async (wmsOrderNo: string, warehouseCd: string) => {
	const url = `${baseUrl}/detail/${wmsOrderNo}/${warehouseCd}`;

	return await getData<ResponseDto<WMS1022_R01DetailDto[]>>(url);
}

export const getWMS1022_R01WmsTransport = async (wmsOrderNo: string) => {
	const url = `${baseUrl}/wmsTransport/${wmsOrderNo}`;

	return await getData<ResponseDto<WmsTransportHeaderDto>>(url);
}

export const getWMS1022_R01LotList = async (wmsOrderNo: string, warehouseCd: string, itemCd: string) => {
	const url = `${baseUrl}/lot`;

	return await getData<ResponseDto<WMS1022_R01LotDto[]>>(url, { params: { 
			transportNo : wmsOrderNo || undefined,
			warehouseCd : warehouseCd || undefined,
			itemCd : itemCd || undefined
		} 
	});
}

export const createWMS1022_R01LotNo = async () => {
	const url = `${baseUrl}/lot/createLotNo`;
	return await getData<ResponseDto<string>>(url);
}

export const postWMS1022_R01 = async (data: WMS1022_R01Dto) => {

	const url = `${baseUrl}`;

	return await postData<WMS1022_R01Dto, ResponseDto<WMS1022_R01Dto[]>>(url, data);
}

export const patchWMS1022_R01 = async (data: WMS1022_R01Dto) => {

	const url = `${baseUrl}`;

	return await patchData<WMS1022_R01Dto, ResponseDto<WMS1022_R01Dto[]>>(url, data);
}

export const deleteWMS1022_R01 = async (wmsOrderNo: string) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<any>>(url, {
		params: {
			wmsOrderNo
		}
	});
}

export const downloadExcel_WMS1022_R01 = async (option: string, wmsOrderNo: string, warehouseCd: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			wmsOrderNo,
			warehouseCd
		}
	})
}